import React from 'react';
import '../styles/Steps.css';

const Steps = ({ currentStep, setCurrentStep, steps }) => {
  // Handle step change
  const handleStepClick = (step) => {
    console.log('Navigating to:', step); // Debugging log
    setCurrentStep(step); // Directly update the current step
  };

  return (
    <div className="steps-container">
      <h3 className="steps-title">Steps</h3>
      <ul className="steps-list">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`step-item ${currentStep === step ? 'active' : ''}`}
            onClick={() => handleStepClick(step)}
          >
            <div className="step-indicator">
              <span
                className={`circle ${
                  currentStep === step ? 'active-circle' : ''
                }`}
              />
              {index < steps.length - 1 && (
                <span className="vertical-line"></span>
              )}
            </div>
            <span className="step-label">{step}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Steps;


// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../styles/Steps.css';

// const Steps = ({ currentStep, setCurrentStep, steps }) => {
//   const navigate = useNavigate();

//   // Handle step change and navigation
//   const handleStepClick = (step) => {
//     setCurrentStep(step);

//     // Define the routes associated with each step
//     const stepRoutes = {
//       'Project Description': '/projectdescription',
//       'Tasks and Team': '/taskandteam',
//       'Project Dates': '/projectdates',
//       'Additional Details': '/additionaldetails',
//       'Summary': '/summary',
//     };

//     // Navigate to the corresponding route
//     navigate(stepRoutes[step]);
//   };

//   return (
//     <div className="steps-container">
//       <h3 className="steps-title">Steps</h3>
//       <ul className="steps-list">
//         {steps.map((step, index) => (
//           <li
//             key={index}
//             className={`step-item ${currentStep === step ? 'active' : ''}`}
//             onClick={() => handleStepClick(step)}
//           >
//             <div className="step-indicator">
//               <span className={`circle ${currentStep === step ? 'active-circle' : ''}`} />
//             </div>
//             <span className="step-label">{step}</span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Steps;
